export default __webpack_public_path__ + "static/media/gray_small.b9e5dfed.png";